import React, { useEffect, useState } from "react";

import Logo from "components/Logo";
import { useWaitlist } from "contexts/waitlist";
import "./navigation.scss";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const { openModal } = useWaitlist();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`navigation ${scrolled ? "scrolled" : ""}`}>
      <div className="navigation-inner">
        <a href="/" className="wordmark">
          <Logo variant={scrolled ? "dark" : "light"} />
        </a>
        <button className="nav-cta" onClick={openModal}>
          Join Waitlist
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
